const e = {
  selectionItems: []
};
export { e as SelectionItemsDefaultProps };